goog.provide("shadow.js.shim.module$$mui$material$Divider$default");
shadow.js.shim.module$$mui$material$Divider$default = shadow.js.require(457, {})["default"];
